import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

// Components
import Button from "../../../../components/button";

// Context
import { useCoursesNewContext } from "../context";

// Assets
import processingMascot from "../../../../components/assets/logo.png";

// Utils
import * as urls from "../../../../utils/urls";

// Styles
import styles from "./style.module.css";

const Finished: React.FC = () => {
  const { t } = useTranslation();

  // Context
  const { course } = useCoursesNewContext();

  const handleStart = useCallback(() => {
    if (course?.id) {
      Turbo.visit(urls.courseUrl(course.id));
    } else {
      Turbo.visit(urls.coursesUrl());
    }
  }, [course?.id]);

  return (
    <div className='flex flex-col items-center justify-center gap-4'>
      <h1 className='text-2xl text-black dark:text-white'>
        {t('courses.new.finished.all_set.part_1')}
        <span className='text-purple-500 dark:text-indigo-500 text-transparent bg-clip-text bg-gradient-to-t from-purple-500 to-red-500'>
          {t('courses.new.finished.all_set.part_2')}
        </span>
        {t('courses.new.finished.all_set.part_3')}
      </h1>

      <p className='text-2xl text-black dark:text-white'>
        {t('courses.new.finished.all_set.subtitle')}
      </p>

      <img src={processingMascot} alt="Finished" className='w-1/2 h-1/2 mx-auto' />


      <p className='text-md text-black dark:text-white'>
        {t('courses.new.finished.all_set.adapt_to_you')}
      </p>

      <div className='flex flex-row items-center justify-center gap-4 w-full'>
        <Button className={styles.button} type='primary' onClick={handleStart}>
          {t('actions.start')}
        </Button>
      </div>
    </div>
  )
};

export default Finished;
